import React, { useRef, useState } from "react";

import classNames from "classnames";
import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import KontentItemImage from "../../templates/kontentItemImage";
import SocialMediaShare from "../socialMediaShare/socialMediaShare";
import MuteButton from "../video/muteButton";
import PlayVideoButton from "../video/playVideoButton";
import VideoBackgroundPlayer from "../video/videoBackgroundPlayer";

const HeroCampaign = ({
  children,
  data = null,
  eyecatcher = null,
  date = null,
  disableShareButtons = false,
}) => {
  const videoPlayer = useRef(null);
  const [muted, setMuted] = useState(true);

  const isVideo = data?.value?.length > 0 && data.value[0].system.type === "video";
  let convertedData = null;
  let hideMuteButton = false;

  if (isVideo) {
    const video = data?.value ? data.value[0] : data;
    convertedData = JSON.parse(video.elements.convert_video.value);
    hideMuteButton = video.elements.hide_mute_button.value.length > 0 && video.elements.hide_mute_button.value[0].codename === "true";
  }

  return (
    <div className="container--fullwidth">
      <div className={classNames("hero-headline hero-headline--campaign", { "hero-headline--eyecatcher": eyecatcher })}>
        {isVideo
          ? (
            <div className="hero-headline__gradient">
              <VideoBackgroundPlayer
                ref={videoPlayer}
                src={convertedData}
                muted={muted}
                setMuted={setMuted}
              >
                <div className="container-fluid">
                  {!hideMuteButton && <MuteButton muted={muted} setMuted={setMuted} />}
                  {date !== null && (
                    <div className="hero-headline__category-container">
                      <div className="hero-headline__category">
                        <FormattedMessage id="hero_carousel_card.campaign" />
                      </div>
                      <div className="hero-headline__date">{date}</div>
                    </div>
                  )}
                  <h1 className={classNames("hero-headline__headline")}>{children}</h1>
                  {!disableShareButtons && (<SocialMediaShare white />)}
                  <PlayVideoButton videoPlayerRef={videoPlayer} />
                </div>
              </VideoBackgroundPlayer>
            </div>
          )
          : (
            <>
              <div className="hero-headline__gradient">
                <div className="container-fluid">
                  <Row>
                    <Col md={10} lg={8}>
                      {date !== null && (
                        <div className="hero-headline__category-container">
                          <div className="hero-headline__category">
                            <FormattedMessage id="hero_carousel_card.campaign" />
                          </div>
                          <div className="hero-headline__date">{date}</div>
                        </div>
                      )}
                      <h1 className={classNames("hero-headline__headline")}>{children}</h1>
                      {!disableShareButtons && (<SocialMediaShare white />)}
                    </Col>
                  </Row>
                </div>
              </div>
              <KontentItemImage data={data} width={1920} height={660} fixed className="img-fluid" />
            </>
          )}
      </div>
      {eyecatcher && (
        <Container fluid className="hero-headline__eyecatcher-container">
          {eyecatcher}
        </Container>
      )}
    </div>
  );
};

HeroCampaign.propTypes = {
  children: PropTypes.node.isRequired,
  data: PropTypes.oneOfType([PropTypes.object]),
  date: PropTypes.node,
  disableShareButtons: PropTypes.bool,
  eyecatcher: PropTypes.oneOfType([PropTypes.object]),
};

export default HeroCampaign;
